// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"86398674","508":"2f3bdf13","639":"cdfc9d6f","857":"24564325","950":"9830434d"}[chunkId] + ".chunk.js";
};